/** Wordsize of CPUVS */
export const WORD_SIZE = 2;
